export const Types = {
  ADD_TABELAS_CONVENIOS: "filtrosTabelasConvenios/ADD_TABELAS_CONVENIOS"
};

const INITIAL_STATE = {
  bancos: [],
  promotoras: [],
  produtos: [],
  operacoes: [],
  status: []
};

export default function filtrosTabelasConvenios(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ADD_TABELAS_CONVENIOS:
      return {
        ...state,
        bancos: action.payload.data.bancos,
        promotoras: action.payload.data.promotoras,
        produtos: action.payload.data.produtos,
        operacoes: action.payload.data.operacoes,
        status: action.payload.data.status
      };
    case Types.CLOSE:
      return { ...state, open: false };
    default:
      return state;
  }
}

export const Creators = {
  addTabelasConveniosFiltro: data => ({
    type: Types.ADD_TABELAS_CONVENIOS,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/filtrosTabelasConvenios.js